export const EMAIL_SUPPORT = ['support@gempages.help', 'gemx-support@gemcommerce.com'];
export const EMAIL_GEMCOMMERCE = ['gempages.help', 'gemcommerce.com'];
